// As datas de planeamento estão guardadas na BD como texto, em formatos mistos:
//   "2026-07-31T05:00:00.000Z", "2026-07-31T08:00:00+01:00",
//   "2026-07-31T07:00:00.000000+00:00", "2026-07-31T10:00", "2026-07-31 10:00:00"
// O "Z"/offset faz com que o browser (e o FullCalendar/DayPilot) converta a hora
// para o fuso do utilizador, mostrando um horário diferente do que está na BD.
// Estas funções descartam o fuso e mantêm a hora literal ("wall clock") da BD.

const ISO_DATETIME = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

// Normaliza uma data vinda da BD para "YYYY-MM-DDTHH:mm:ss" (sem fuso).
// Datas só com dia ("2026-07-31") ficam inalteradas; valores vazios/inválidos
// são devolvidos tal como vieram, para não mascarar problemas de dados.
export function normalizarDataBD(valor) {
  if (!valor) return valor;
  if (valor instanceof Date) return formatarDataLocal(valor);

  const texto = String(valor);
  const m = ISO_DATETIME.exec(texto);
  if (!m) return texto;

  const [, ano, mes, dia, horas, minutos, segundos] = m;
  return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos || "00"}`;
}

// Devolve um Date construído com os componentes literais da BD (hora local do
// browser), para ordenações e comparações sem desvio de fuso.
export function parseDataBD(valor) {
  if (!valor) return null;
  if (valor instanceof Date) return valor;

  const texto = String(valor);
  const m = ISO_DATETIME.exec(texto) || ISO_DATE.exec(texto);
  if (!m) {
    const d = new Date(valor);
    return isNaN(d.getTime()) ? null : d;
  }

  const [, ano, mes, dia, horas, minutos, segundos] = m;
  return new Date(
    Number(ano),
    Number(mes) - 1,
    Number(dia),
    Number(horas || 0),
    Number(minutos || 0),
    Number(segundos || 0)
  );
}

// Formata um Date para "YYYY-MM-DDTHH:mm:ss" sem fuso, para gravar na BD
// exactamente a hora que está a ser mostrada no calendário.
export function formatarDataLocal(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}` +
    `T${p(date.getHours())}:${p(date.getMinutes())}:${p(date.getSeconds())}`
  );
}

// Formata um Date para "YYYY-MM-DD" pelo calendário local.
// Usar sempre isto em vez de toISOString().slice(0, 10): o toISOString converte
// para UTC, o que desloca o dia um para trás em fusos a leste (Portugal no
// verão) e um para a frente em fusos a oeste (Cabo Verde, perto da meia-noite).
export function formatarDiaLocal(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
}

// Dia de hoje ("YYYY-MM-DD") no calendário local do utilizador.
export function hojeLocal() {
  return formatarDiaLocal(new Date());
}

// Aplica normalizarDataBD aos campos indicados de um objecto (não muta o original).
export function normalizarCamposData(obj, campos = ["inicio", "fim"]) {
  if (!obj) return obj;
  const copia = { ...obj };
  for (const campo of campos) {
    if (copia[campo]) copia[campo] = normalizarDataBD(copia[campo]);
  }
  return copia;
}
